<!--
  Sub-modale "Codici QR sub-prodotto" — Diakonix native (v2.11.0 J.4.c).
  Z-index 2200 (sopra confirm-products 2100).
  Cross-use con storico-ordini/product-details-storico (v2.9.0).
-->
@if (openedSubQrs) {
  <div class="sq-backdrop" (click)="close()">
    <div
      class="sq-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="sq-title"
      (click)="$event.stopPropagation()"
    >
      <header class="sq-header">
        <div class="sq-title-block">
          <h2 id="sq-title">🔍 Codici QR sub-prodotto</h2>
          @if (subProduct?.osp_description) {
            <p class="sq-subtitle">{{ subProduct.osp_description }}</p>
          }
        </div>
        <button
          type="button"
          class="sq-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <div class="sq-body">
        @if (parentProduct && subProduct && parentProduct.sub_products[index_subProduct]?.barcodes?.length > 0) {
          <div class="sq-table">
            <div class="sq-table-head">
              <div class="sq-th">#</div>
              <div class="sq-th">Codice</div>
              <div class="sq-th">Lotto</div>
              <div class="sq-th">Progressivo</div>
              <div class="sq-th">Data scansione</div>
            </div>

            <div class="sq-table-body">
              @for (
                barcode of parentProduct.sub_products[index_subProduct].barcodes;
                track barcode.barcode_text || $index;
                let i = $index
              ) {
                @if (barcode.barcode_text !== null) {
                  <div class="sq-row">
                    <div class="sq-td sq-td--index">{{ i + 1 }}</div>
                    <div class="sq-td sq-td--code">
                      <span class="sq-code">{{ barcode.barcode_text }}</span>
                    </div>
                    <div class="sq-td">{{ barcode.lot || '—' }}</div>
                    <div class="sq-td">{{ barcode.progressive || '—' }}</div>
                    <div class="sq-td">
                      {{ barcode.scanned_date ? (barcode.scanned_date | date:'dd/MM/yyyy') : '—' }}
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        } @else {
          <div class="sq-empty">
            <div class="sq-empty__icon">📭</div>
            <p>Nessun codice QR disponibile per questo sub-prodotto.</p>
          </div>
        }
      </div>

      <footer class="sq-footer">
        <button
          type="button"
          class="sq-btn sq-btn--close"
          (click)="close()"
        >
          <i class="bx bx-check"></i>
          Chiudi
        </button>
      </footer>
    </div>
  </div>
}
